import React from 'react';
import Loading from 'components/Loading';
import cn from 'classnames';
import styles from '../ExternalAppointment.module.scss';
import errorMessages from 'constants/errorMessages';
import Warning from 'components/Warning';

export function SlotLoadingStatus({ isLoading, isError, children }) {
  if (isError) {
    return (
      <div className={styles.SlotLoadingStatus}>
        <Warning message={errorMessages.appointmentServiceError} />
      </div>
    );
  }
  if (isLoading) {
    return (
      <div className={cn(styles.SlotLoadingStatus, 'loading-container')}>
        <Loading />
      </div>
    );
  }
  return children || null;
}
